import { Database } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import AppNavActions from './AppNavActions';

/**
 * The application's top bar: the ARA mark, the primary links and the account
 * menu.
 *
 * Kept shorter than the bar on other pages, for screens that need most of the
 * window for their own content.
 */
export default function AppHeader() {
  const navigate = useNavigate();

  return (
    <nav className="z-40 shrink-0 border-b border-gray-100 bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <button
            type="button"
            onClick={() => navigate('/')}
            className="group flex items-center space-x-3 text-left"
          >
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-emerald-800 text-white shadow-lg shadow-emerald-200 transition-transform duration-300 group-hover:scale-110">
              <Database className="h-5 w-5" />
            </div>
            <div>
              <span className="text-xl font-bold tracking-tight text-emerald-800">ARA</span>
              <span className="-mt-1 block text-xs font-medium tracking-widest text-gray-400 opacity-60">
                Automated Records Assistant
              </span>
            </div>
          </button>
          <AppNavActions />
        </div>
      </div>
    </nav>
  );
}
